import React, { useEffect, useState, Suspense, lazy,useContext } from "react";
import { useSelector } from "react-redux";
//import ReactGA from "react-ga4";
import { analytics } from "./components/firebase";
import { logEvent } from "firebase/analytics";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { CollectionSkeleton } from "./components/skeleton";
import Loader from "./components/loader";
import AuthContext from "./components/authContext";
import CenteredSpinner from "./components/spinner";
import SplashScreen from "./components/splashScreen";
// Lazy-loaded components
import HomePage from "./pages/HomePage";
import InternetConnectivity from "./components/networkConnection";
import LoaderComponent from "./components/loaderComponent";


const Cart = lazy(() => import("./pages/cart"));
const AddressList = lazy(() => import("./pages/billingaddress"));
const PaymentPage = lazy(() => import("./pages/payment"));
const ProductDetailCard = lazy(() => import("./pages/productDetailCard"));
const Login = lazy(() => import("./pages/login"));
const Register = lazy(() => import("./pages/register"));
const ForgotPassword = lazy(() => import("./pages/forogtPassword"));
const EditAddress = lazy(() => import("./pages/addressPage"));
const AddressForm = lazy(() => import("./pages/addAddress"));
const MyOrderPage = lazy(() => import("./pages/myOrders"));
const OrderDetailPage = lazy(() => import("./pages/orderDetail"));
const OrderSuccess = lazy(() => import("./pages/orderPage"));
const BrandPage = lazy(() => import("./pages/brandsPage"));
const CategoryPage = lazy(() => import("./pages/CategoriesDetail"));
const CollectionPage = lazy(() => import("./pages/collectionDetail"));
const MyAccount = lazy(() => import("./pages/profileAccount"));
const SearchPage = lazy(() => import("./pages/searchPage"));

// Admin Pages
const AdminDashboard = lazy(() => import("../src/admin/adminPages/adminDashboard"));
const AdminProducts = lazy(() => import("../src/admin/adminPages/adminProducts"));
const AdminCategory = lazy(() => import("../src/admin/adminPages/adminCategories"));
const AdminUserCartPage = lazy(() => import("../src/admin/adminPages/adminUserCarts"));
const AdminAllOrders = lazy(() => import("../src/admin/adminPages/adminAllOrders"));
const AdminOrderDetail = lazy(() =>import("./admin/adminPages/adminOrderByID"));
const AdminCustomers = lazy(() => import("./admin/adminComponent/adminCustomers"));

//ReactGA.initialize("G-97ZETX9ZXL"); // GA4 Measurement ID
const App = () => {
 const { user, isLoggedIn,isLoading} = useContext(AuthContext); 
 const [showSplash, setShowSplash] = useState(false);
 const wishlist = useSelector(state => state.wishlist);

  useEffect(() => {
    const splashShown = sessionStorage.getItem("splashShown");
    if (!splashShown) {
      setShowSplash(true);
      setTimeout(() => {
        sessionStorage.setItem("splashShown", "true");
        setShowSplash(false);
      }, 3000); // 3 सेकंड बाद स्प्लैश हटाएं
    }
  }, []);

 useEffect(() => {
  if (user) {
    // Page view event ko log karo
    logEvent(analytics, "page_view", {
      page_location: window.location.href,   // Complete URL
      page_path: window.location.pathname,   // Relative path
      page_title: document.title,            // Page title
      screen_resolution: `${window.screen.width}x${window.screen.height}`,  // Screen resolution
    });
  
    // Log a custom event
    logEvent(analytics, "user_login", {
      user_phone: user?.phone,
    });
  }
}, [user]);
if (isLoading) {
  return (
    <CenteredSpinner/>    
  );
}

console.log("Wishlist Items:", wishlist);

// if (showSplash) {
//   return (
//     <SplashScreen/>    
//   );
// }

const ProtectedRoute = ({ children }) => {
    if (isLoading) return <Loader />; // Show loader until loading is complete
    return isLoggedIn ? children : <Navigate to="/login" />;
  };
  // 🔹 **Admin Protected Route**
const AdminProtectedRoute = ({ children }) => {
  if (isLoading) return <CenteredSpinner />; // Show loader until loading is complete
    return isLoggedIn && user?.userType === 1 ? children : <Navigate to="/" />;
};


  return (
    <Router>
      <InternetConnectivity/>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={showSplash ? <SplashScreen/> : <HomePage />}/>
        <Route path="/cart" element={<Suspense fallback={<Loader />}><Cart /></Suspense>} />
        <Route path="/login" element={<Suspense fallback={<Loader />}><Login /></Suspense>} />
        <Route path="/register" element={<Suspense fallback={<Loader />}><Register /></Suspense>} />
        <Route path="/forgotpassword" element={<Suspense fallback={<Loader />}><ForgotPassword /></Suspense>} />
        <Route path="/brand/:brands" element={<Suspense fallback={<CollectionSkeleton />}><BrandPage /></Suspense>} />
        <Route path="/category/:category" element={<Suspense fallback={<CollectionSkeleton />}><CategoryPage /></Suspense>} />
        <Route path="/collection/:collection" element={<Suspense fallback={<CollectionSkeleton />}><CollectionPage /></Suspense>} />
        <Route path="/product/:id" element={<Suspense fallback={<Loader />}><ProductDetailCard /></Suspense>} />
        <Route path="/search" element={<Suspense fallback={<LoaderComponent />}><SearchPage /></Suspense>} />

        {/* Protected Routes (Users must be logged in) */}
        <Route path="/profile" element={<ProtectedRoute><Suspense fallback={<Loader />}><MyAccount /></Suspense></ProtectedRoute>} />
        <Route path="/orders" element={<ProtectedRoute><Suspense fallback={<Loader />}><MyOrderPage /></Suspense></ProtectedRoute>} />
        <Route path="/orderdetail/:orderID" element={<ProtectedRoute><Suspense fallback={<Loader />}><OrderDetailPage /></Suspense></ProtectedRoute>} />
        <Route path="/ordersuccess" element={<ProtectedRoute><Suspense fallback={<Loader />}><OrderSuccess /></Suspense></ProtectedRoute>} />
        <Route path="/address" element={<ProtectedRoute><Suspense fallback={<Loader />}><AddressList /></Suspense></ProtectedRoute>} />
        <Route path="/addaddress" element={<ProtectedRoute><Suspense fallback={<Loader />}><AddressForm /></Suspense></ProtectedRoute>} />
        <Route path="/editaddress" element={<ProtectedRoute><Suspense fallback={<Loader />}><EditAddress /></Suspense></ProtectedRoute>} />
        <Route path="/payment" element={<ProtectedRoute><Suspense fallback={<Loader />}><PaymentPage /></Suspense></ProtectedRoute>} />

        {/* Admin Protected Routes */}
        <Route path="/admin/dashboard" element={<AdminProtectedRoute><Suspense fallback={<Loader />}><AdminDashboard /></Suspense></AdminProtectedRoute>} />
        <Route path="/admin/products" element={<AdminProtectedRoute><Suspense fallback={<Loader />}><AdminProducts /></Suspense></AdminProtectedRoute>} />
        <Route path="/admin/categories" element={<AdminProtectedRoute><Suspense fallback={<Loader />}><AdminCategory /></Suspense></AdminProtectedRoute>} />
        <Route path="/admin/usercarts" element={<AdminProtectedRoute><Suspense fallback={<CenteredSpinner />}><AdminUserCartPage /></Suspense></AdminProtectedRoute>} />
        <Route path="/admin/orders" element={<AdminProtectedRoute><Suspense fallback={<CenteredSpinner />}><AdminAllOrders /></Suspense></AdminProtectedRoute>} />
        <Route path="/admin/order/:orderId" element={<AdminProtectedRoute><Suspense fallback={<CenteredSpinner />}><AdminOrderDetail /></Suspense></AdminProtectedRoute>} />
        <Route path="/admin/customers" element={<AdminProtectedRoute><Suspense fallback={<CenteredSpinner />}><AdminCustomers /></Suspense></AdminProtectedRoute>} />
        
      </Routes>
    </Router>
  );
};

export default App;
